var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 377.953,
    height: 377.953,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.669 46.664h260.125V220.32H11.669Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 283.465h283.465V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 377.953)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.934 5.934 0 0 1-4.542 2.162l-110.542.806h-.045a5.898 5.898 0 0 1-4.212-1.748 5.872 5.872 0 0 1-1.725-4.24c.072-6.535-.208-16.105-1.687-27.365l57.671-.637a8.24 8.24 0 0 0 6.268-2.993 8.17 8.17 0 0 0 1.753-6.664c-16.595-92.461-78.447-122.58-134.661-130.01 77.12 1.611 168.459 33.209 192.983 165.84A5.911 5.911 0 0 1 0 0",
    style: {
      fill: "#a1c74a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(270.434 217.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-72.244 1.027-.086.001c-3.231 0-5.885-2.611-5.937-5.86-.168-10.644-1.981-31.447-12.23-51.186-12.425-23.928-33.199-39.294-61.746-45.672-1.912-.428-2.523-1.936-2.456-3.205.065-1.262.826-2.692 2.762-2.917 43.298-5.029 120.994 1.747 154.835 103.707a3.1 3.1 0 0 1-.418 2.802A3.068 3.068 0 0 1 0 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(166.373 158.503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a3.12 3.12 0 0 1-2.371 1.133l-90.7 1.001h-.035c-.836 0-1.62-.325-2.209-.919a3.047 3.047 0 0 1-.894-2.223c.068-3.693 0-8.717-.477-14.638l55.465-.789a8.146 8.146 0 0 0 6.589-3.461 8.186 8.186 0 0 0 1.107-7.391c-19.587-59.011-53.43-87.173-87.298-99.62C-68.851-117.676-14.504-86.958.658-2.488.818-1.591.585-.708 0 0",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(207.666 180.068)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetence);
export default __webpack_public_path__ + "static/media/competence.64ee3ccf59561569773af5f499b3651c.svg";
export { ForwardRef as ReactComponent };